import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import ContentContributorsUI from "../components/ContentContributorsFilter";
import CreatorCard from "../components/CreatorCard";
import { useAuth } from "../context/AuthContext";
import { API_BASE } from "../utils/Instance";

export default function ExploreContent() {
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { profile } = useAuth();
  const isContributor = profile?.role === "contributor";
  const initialSearch = searchParams.get("search") || "";

  // When contributor lands with a selected contributor (e.g. from search), show only that profile
  useEffect(() => {
    const contributor = location.state?.selectedContributor;
    if (contributor) {
      setSelectedProfile(contributor);
      navigate(location.pathname + (location.search || ""), { replace: true, state: {} });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run only when state.selectedContributor changes
  }, [location.state]);

  useEffect(() => {
    if (!selectedProfile?.id || !profile?.accessToken) return;

    fetch(`${API_BASE}accounts/profile/record-profile-visit/`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${profile.accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ contributor_id: selectedProfile.id }),
    }).catch((error) => {
      console.error("Error recording contributor profile visit:", error);
    });
  }, [selectedProfile?.id, profile?.accessToken]);

  // Contributors must not see the explore grid; redirect to dashboard if they have no profile open
  useEffect(() => {
    if (!isContributor) return;
    if (!selectedProfile && !location.state?.selectedContributor) {
      navigate("/dashboard", { replace: true });
    }
  }, [isContributor, selectedProfile, location.state?.selectedContributor, navigate]);

  return (
    <div className="flex min-h-screen bg-black">
      <Sidebar />
      <div className="flex-1 p-4 md:p-6 lg:ml-64 w-full">
        <Topbar pageTitle="Explore Content" />
        {!isContributor && (
          <ContentContributorsUI onContributorClick={setSelectedProfile} initialSearch={initialSearch} />
        )}
      </div>

      {selectedProfile && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 px-4">
          <div className="bg-[#1c1c1e] rounded-xl p-6 w-full max-w-md max-h-[90vh] overflow-y-auto shadow-lg border border-[#ceb46a]">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-bold text-white">Contributor Details</h2>
              <button
                onClick={() => setSelectedProfile(null)}
                className="text-white text-xl font-bold hover:text-[#ceb46a]"
              >
                ✖
              </button>
            </div>
            <CreatorCard {...selectedProfile} detailedView={true} />
          </div>
        </div>
      )}
    </div>
  );
}
